export class UploadItem {
    constructor(optionalOptions = {}) {
        $(document).on('click', ".upload-button", function() {
            let idInput = $(this).attr('data-target');
            $("input[id=" + idInput + "]").click();
        });

        $(document).on('click', ".base-form-upload-input-delete", function() {
            var img = $(this).parent().find('img').first();
            var attrEmpty = img.attr('data-empty');
            img.attr('src', attrEmpty);
            $(this).parent().addClass('upload-button--empty');
            $(this).parent().parent().find('.upload-input').first().val('');
        });

        $(document).on('change', ".upload-input", function() {
            let idImg = $(this).attr('id');
            let input = this;

            if (input.files && input.files[0]) {
                var reader = new FileReader();
                var extension = input.files[0].name.split('.').pop().toLowerCase()

                if (extension !== 'mp4') {
                    reader.onload = function (e) {
                        var imgSrc = $('img[data-target="' + idImg + '"]');

                        imgSrc.attr('src', e.target.result);

                        $(input).parent().find('.base-form-upload-input--wrap').first().removeClass('upload-button--empty')
                    }
                    reader.readAsDataURL(input.files[0]); // convert to base64 string
                } else {
                    var imgSrc = $('img[data-target="' + idImg + '"]');
                    var dataVideo = imgSrc.attr('data-video')
                    imgSrc.attr('src', dataVideo);
                    $(input).parent().find('.base-form-upload-input--wrap').first().removeClass('upload-button--empty');
                }
            }
        });
    }

    destructor() {
    }
}

export default new UploadItem();
